import { render, staticRenderFns } from "./CerrarOVRechazado.vue?vue&type=template&id=5623b3b9&scoped=true&lang=pug"
import script from "./CerrarOVRechazado.vue?vue&type=script&lang=js"
export * from "./CerrarOVRechazado.vue?vue&type=script&lang=js"
import style0 from "./CerrarOVRechazado.vue?vue&type=style&index=0&id=5623b3b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5623b3b9",
  null
  
)

export default component.exports